<div class="kendo-formfield left-search-icon multi">
  <kendo-label text="{{ label }}"></kendo-label>
  <div style="position: relative;">
    <i class="fa fa-search" aria-hidden="true"></i>
    <kendo-multiselect #multiSelect
      [checkboxes]="true"
      [autoClose]="false"
      [loading]="loading"
      [valuePrimitive]="true"
      [data]="sageClasses"
      [(ngModel)]="selectedValue"
      [rounded]="'full'"
      valueField="id"
      textField="name"
      [tagMapper]="tagMapper"
      [placeholder]="placeholder"
      [fillMode]="'outline'"
      [kendoDropDownFilter]="{ caseSensitive: false, operator: 'startsWith' }"
      [disabled]="disabled"
      (valueChange)="onValueChange($event)"
      (filterChange)="onSearchChange($event)"
      (focus)="onFocus()"
      (keydown.enter)="onEnterPress()">
      <ng-template kendoMultiSelectItemTemplate let-dataItem>
        <span style="padding-left: 5px;">{{ dataItem?.name }}</span>
      </ng-template>
      <ng-template kendoMultiSelectNoDataTemplate *ngIf="!searchString">
        PLEASE SEARCH SOMETHING...
      </ng-template>
      <ng-template kendoMultiSelectNoDataTemplate *ngIf="searchString">
        NO DATA FOUND
      </ng-template>
    </kendo-multiselect>
  </div>
</div>
